import {
  PitchDistance,
  PitchPosition,
} from '@collector/mobile-feature-goal-and-pitch-positions'
import {
  HandballAttributeId,
  HandballThrowBlockedAttribute,
} from '@collector/sportsapi-client-legacy'

export const pitchDistanceAttributeMap = new Map<
  PitchDistance,
  HandballAttributeId
>([
  ['6m', HandballThrowBlockedAttribute.SixMeter],
  ['9m', HandballThrowBlockedAttribute.NineMeter],
])

export const pitchPositionAttributeMap = new Map<
  PitchPosition,
  HandballAttributeId
>([
  ['left', HandballThrowBlockedAttribute.LeftSide],
  ['right', HandballThrowBlockedAttribute.RightSide],
  ['left-wing', HandballThrowBlockedAttribute.LeftWing],
  ['right-wing', HandballThrowBlockedAttribute.RightWing],
  ['center', HandballThrowBlockedAttribute.Center],
])
